module.exports = __webpack_public_path__ + "static/media/transaction-failed.1dbcf90e.png";